export default __webpack_public_path__ + "static/media/global.03ab91a8.less";